import connect from './connect';
import ProjectTemplates from './ProjectTemplates';

export default connect(ProjectTemplates);
